import React, { FC } from 'react';
import { BodyText, ButtonProps, FlexCol, FlexRow, TextDynamic } from '@minecraft.atoms';
import Icon from '@minecraft.icon';
import { useTranslation } from '@blocs.i18n';
import Modal from '@minecraft.modal';

export type ConfirmationModalProps = {
  isOpen?: boolean;
  close?: () => void;
  onSubmit?: () => void;
  icon?: string;
  header?: string;
  descriptionLineOne?: string;
  descriptionLineTwo?: string;
  cancelLabel?: string;
  submitLabel?: string;
  dataTestId?: string;
};

export const ConfirmationModal: FC<ConfirmationModalProps> = ({
  isOpen,
  close,
  onSubmit,
  icon,
  header,
  descriptionLineOne,
  descriptionLineTwo,
  cancelLabel,
  submitLabel,
  dataTestId = 'confirmation',
}) => {
  const { t } = useTranslation();
  const modalButtons: ButtonProps[] = [
    {
      label: cancelLabel || t('common:button.cancel'),
      onClick: close,
      variant: 'secondary',
    },
    {
      label: submitLabel || t('common:button.submit'),
      onClick: onSubmit,
    },
  ];
  return (
    <Modal
      title=""
      data-testid={`${dataTestId}-modal`}
      isHeaderHidden
      noPadding
      isOpen={isOpen}
      modalSize="large"
      handleToggleClick={close}
      buttons={modalButtons}
    >
      <FlexCol gap="8" className="cn_mx-8 cn_mt-8">
        <FlexRow justifyContent="center">
          <TextDynamic
            fontSize="h1"
            fontWeight="semibold"
            color="default"
            align="left"
            className="cn_w-full"
            mdProps={{ fontSize: 'xl', fontWeight: 'semibold', align: 'center', className: 'cn_w-4/5' }}
          >
            {icon && <Icon name={icon} size="xl" className="mr-2" />}
            {header}
          </TextDynamic>
          <FlexRow className="cn_mt-8" gap="8">
            {descriptionLineOne && <BodyText>{descriptionLineOne}</BodyText>}
            {descriptionLineTwo && <BodyText>{descriptionLineTwo}</BodyText>}
          </FlexRow>
        </FlexRow>
      </FlexCol>
    </Modal>
  );
};
